"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode, Suspense, useEffect } from "react";
import { ThemeProvider } from "next-themes";
import QueryProvider from "@/providers/QueryProvider";
import { useUserStore } from "@/stores/useAuthStore";
import { useQueryClient } from "@tanstack/react-query";
import { getCookie } from "@/lib/cookies";
import { getMySubscription } from "@/services/subscription";
import { getMyPurchasedTickets } from "@/services/tickets";
import { Toaster } from "react-hot-toast";
import HomeLoading from "@/components/pages/home/loading";
interface LayoutProviderProps {
  children: ReactNode;
}
function StoreHydrator() {
  const $ = _c(3);
  const queryClient = useQueryClient();
  let t0;
  let t1;
  if ($[0] !== queryClient) {
    t0 = () => {
      useUserStore.persist.rehydrate();
      const token = getCookie("access_token");
      if (token) {
        queryClient.prefetchQuery({
          queryKey: ["my-subscription"],
          queryFn: getMySubscription,
          staleTime: 300000
        });
        queryClient.prefetchQuery({
          queryKey: ["my-purchased-tickets"],
          queryFn: getMyPurchasedTickets,
          staleTime: 300000
        });
      }
    };
    t1 = [queryClient];
    $[0] = queryClient;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}
export default function LayoutProvider(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <StoreHydrator />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HomeLoading />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <QueryProvider>{t1}<Suspense fallback={t2}>{children}</Suspense></QueryProvider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Toaster position="top-right" toastOptions={{
      duration: 3000
    }} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <ThemeProvider attribute="class" defaultTheme="dark" forcedTheme="dark">{t3}{t4}</ThemeProvider>;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}